import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { PRIVACY_CHOICES_URL } from '../../data/structured-data';

@Component({
  selector: 'app-privacy',
  imports: [RouterLink],
  templateUrl: './privacy.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './privacy.scss',
})
export class Privacy {
  private readonly seoService = inject(SeoService);
  private readonly cookieConsentService = inject(CookieConsentService);
  protected readonly seoTitle = 'Mari Group – Privacy';
  protected readonly seoDescription =
    'How Mari Group processes personal data, and where to find the privacy notice for you — whether you are a website visitor, contractor, employee, or event attendee.';
  protected readonly privacyChoicesUrl = PRIVACY_CHOICES_URL;

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy', path: '/privacy' },
      ],
    });
  }

  protected openCookieSettings(): void {
    this.cookieConsentService.openSettings();
  }
}
